import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, UserLogin } from 'ngx-sds-login';
import { Observable, Subject, combineLatest, takeUntil } from 'rxjs';
import { ObtenerPreguntasRespuestasI } from 'src/app/infraestructure/models/obtenerPreguntasRespuestas';
import { EnviarEncuestaI, RespuestaEncuestaI } from 'src/app/infraestructure/models/responderEncuesta';
import { SurveyService } from 'src/app/infraestructure/services/survey/survey.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-encuesta-satisfaccion',
  templateUrl: './encuesta-satisfaccion.component.html',
  styleUrls: ['./encuesta-satisfaccion.component.scss']
})
export class EncuestaSatisfaccionComponent implements OnInit {
  
  private $topSubcription = new Subject<void>();
  user$: Observable<UserLogin>;
  
  preguntasEncuesta: ObtenerPreguntasRespuestasI[] = [];
  respuestasEncuesta: ObtenerPreguntasRespuestasI[] = [];
  respuestasUsuario: RespuestaEncuestaI[] = [{encuestaPreguntaId: 0, encuestaRespuestaId: 0, solicitudId: 0, usuarioId: 0}, {encuestaPreguntaId: 0, encuestaRespuestaId: 0, solicitudId: 0, usuarioId: 0}, {encuestaPreguntaId: 0, encuestaRespuestaId: 0, solicitudId: 0, usuarioId: 0}];
  solicitudID: number = 0;
  userId: number = 0;
  rolId: number = 2;
  nombreUsuario: string = '';
  dataObservaciones: string = '';
  
  constructor(private route: ActivatedRoute,
              private encuestaSrv: SurveyService,
              private store: Store<AppState>,
              private router: Router) {
                this.user$ = this.store.select(state => state.user);
                this.user$.subscribe(user => {
                  this.userId = user.id;
                  this.nombreUsuario = `${user.vcPrimerNombre} ${user.vcPrimerApellido}`
                });
              }

  ngOnInit(): void {
    this.solicitudID = Number(this.route.snapshot.paramMap.get('id'));
    this.obtenerPreguntasRespuestas();
  }

  obtenerPreguntasRespuestas() {
    combineLatest(
      this.encuestaSrv.getObtenerPreguntas(),
      this.encuestaSrv.getObtenerRespuestas(),
    )
    .pipe(takeUntil(this.$topSubcription))
    .subscribe(([
      Preguntas, Respuestas,
    ]: any) => {
      if(Preguntas.code === 200) this.preguntasEncuesta = Preguntas.data;
      if(Respuestas.code === 200) this.respuestasEncuesta = Respuestas.data;
    })
  }

  guardarRespuesta(preguntaIndex: number, respuestaValor: number) {
    this.respuestasUsuario[preguntaIndex] = {
      encuestaPreguntaId: this.preguntasEncuesta[preguntaIndex].id,
      encuestaRespuestaId: respuestaValor,
      solicitudId: this.solicitudID,
      usuarioId: this.userId
    };
  }

  onEnviarEncuesta() {

    // let datos: Array<Record<string, any>> = this.elementsToArrayByRow(`contenedor_preguntas`, 'span.respuestas');
    // let datos = this.obtenerRespuestas('contenedor_preguntas');
    // console.log(datos);
    // return
    const ENCUESTA: EnviarEncuestaI = {
      solicitudId: this.solicitudID,
      usuarioId: this.userId,
      rolId: this.rolId,
      encuestaRespuestas: this.respuestasUsuario,
      txObservacionSugerencias: this.dataObservaciones,
      datos: {}
    }

    this.encuestaSrv.postEncuesta(ENCUESTA)
    .pipe(takeUntil(this.$topSubcription))
    .subscribe(res => {
      if(res.code === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `Envío exitoso`,
          text: `Encuesta enviada exitosamente para la solicitud con el #${res.data[0].solicitudId}`,
          showConfirmButton: true,
          confirmButtonColor: "#004884",
          confirmButtonText: "ACEPTAR",
        });

        this.router.navigate([`/Acceso`]);
      } else {
        const messages = res.errors ? res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n') : res.message;
        
        Swal.fire({
          title: 'Errores',
          icon: 'error',
          html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
          showConfirmButton: true,
          confirmButtonColor: "#004884",
          confirmButtonText: "ACEPTAR",
        });
      }
    });
  }

  /** 
  elementsToArray(elementId: string): Record<string, any> {
    let campos: Record<string, any> = {};
    
    let element = document.getElementById(elementId);
    if(!element) return campos;
    const inputs = element.querySelectorAll("input, textarea");
    inputs.forEach(input => {
        campos[(<HTMLInputElement>input).name] = (<HTMLInputElement>input).value;
    });
    
    const selects = element.querySelectorAll("select");
    selects.forEach(select => {
        campos[(<HTMLSelectElement>select).name] = (<HTMLSelectElement>select).value;
    });
    
    return campos;
  }

  elementsToArrayByRow(containerId: string, row: string): Array<Record<string, any>> {
    let datos: Array<Record<string, any>> = [];
    debugger
    let container = document.getElementById(containerId);
    if(!container) return datos;
    const rows = container.querySelectorAll(row);
    rows.forEach(element => {
        let campos = this.elementsToArray(element.id || '');
        if (Object.keys(campos).length !== 0) {
            datos.push(campos);
        }
    });
    
    return datos;
  }

  obtenerRespuestas(encuestaId: string): Array<Record<string, any>> {
    let respuestas: Array<Record<string, any>> = [];
    let encuesta = document.getElementById(encuestaId);

    if (!encuesta) {
        return respuestas;
    }

    const grupos = encuesta.querySelectorAll(".pregunta");
    grupos.forEach(grupo => {
        let respuestaSeleccionada = grupo.querySelector("input[type='radio']:checked") as HTMLInputElement;
        if (respuestaSeleccionada) {
            respuestas.push({ [respuestaSeleccionada.name]: respuestaSeleccionada.value });
        }
    });

    return respuestas;
  }
  */
}
